import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import JsonLd from "@/components/base/JsonLd";
import HeroSection from "./components/HeroSection";
import CategoryShowcase from "./components/CategoryShowcase";
import WhyUseSection from "./components/WhyUseSection";
import ComparisonTable from "./components/ComparisonTable";
import BlogPreview from "./components/BlogPreview";
import TestimonialWall from "./components/TestimonialWall";
import FaqSection from "./components/FaqSection";
import CtaBanner from "./components/CtaBanner";

const siteUrl = import.meta.env.VITE_SITE_URL || "https://superbuy.beer";

const homeSchema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "name": "superbuy.beer",
      "url": siteUrl,
      "description": "Trusted Superbuy Spreadsheet guides, verified seller lists, and international shopping resources. Find the best Superbuy Spreadsheet 2026 with regularly updated community-verified product links and buying guides for sneakers, streetwear, and fashion.",
      "sameAs": ["https://kaspreadsheet.com/"],
    },
    {
      "@type": "WebSite",
      "name": "superbuy.beer",
      "url": siteUrl,
      "description": "Best Superbuy Spreadsheet 2026 - Trusted Buying Guides & Seller Lists",
      "potentialAction": {
        "@type": "SearchAction",
        "target": {
          "@type": "EntryPoint",
          "urlTemplate": `${siteUrl}/search?q={search_term_string}`,
        },
        "query-input": "required name=search_term_string",
      },
    },
  ],
};

export default function Home() {
  return (
    <>
      <JsonLd data={homeSchema} />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryShowcase />
        <WhyUseSection />
        <ComparisonTable />
        <BlogPreview />
        <TestimonialWall />
        <FaqSection />
        <CtaBanner />
      </main>
      <Footer />
    </>
  );
}